module.exports = __webpack_public_path__ + "static/media/reduce-size.0d23455d.svg";